import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/functions";

// Production Configuration
const firebaseConfig = {
  apiKey: "AIzaSyBRfaic-kj8Ua0Z3niAoR1zazkUCjLCDnA",
  authDomain: "kevin-erp-demo.firebaseapp.com",
  projectId: "kevin-erp-demo",
  storageBucket: "kevin-erp-demo.firebasestorage.app",
  messagingSenderId: "889617498860",
  appId: "1:889617498860:web:a59227f8892c3c89a6dbc9"
};

// Initialize Firebase
// Ensure strict singleton to prevent initialization errors
const app = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();

// Force PROD check (as requested)
if ((import.meta as any).env?.PROD) {
  console.log("[FirebaseClient] Production Mode Active");
}

export const auth = firebase.auth();
export const db = firebase.firestore();
export const storage = firebase.storage();
export const functions = firebase.app().functions("asia-east1");
export const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp;

export { firebase };
export default firebase;

// --- Compat Adapters for Modular Syntax (v9-style on v8-compat) ---
export const collection = (d: any, path: string) => d.collection(path);
export const doc = (d: any, path: string, id?: string) => id ? d.collection(path).doc(id) : d.doc(path);
export const getDoc = (ref: any) => ref.get();
export const getDocs = (ref: any) => ref.get();
export const setDoc = (ref: any, data: any, opts?: any) => ref.set(data, opts);
export const updateDoc = (ref: any, data: any) => ref.update(data);
export const addDoc = (ref: any, data: any) => ref.add(data);
export const deleteDoc = (ref: any) => ref.delete();
export const onSnapshot = (ref: any, next: any, error?: any) => ref.onSnapshot(next, error);

// Query builders
export const query = (ref: any, ...fns: any[]) => {
    let q = ref;
    for (const fn of fns) {
        if (typeof fn === 'function') q = fn(q);
    }
    return q;
};
export const where = (field: string, op: any, val: any) => (q: any) => q.where(field, op, val);
export const orderBy = (field: string, dir?: 'asc' | 'desc') => (q: any) => q.orderBy(field, dir);
export const limit = (n: number) => (q: any) => q.limit(n);
/* Fix: Add missing startAt and endAt helpers for range/prefix queries */
export const startAt = (val: any) => (q: any) => q.startAt(val);
export const endAt = (val: any) => (q: any) => q.endAt(val);